<template>
    <div id="infinite-list" class="main-wrapper scroll-y custom-scrollbar with-tabs view-news">

        <page-title :title="'Pytania i odpowiedzi'" :back="true"></page-title>

        <!--<div v-for="(item,index) in helps" :key="item.slug">-->
            <!--<item-help-->
                    <!--:index="index+1"-->
                    <!--:slug="item.slug"-->
                    <!--:question="item.question"-->
                    <!--:answer="item.answer">-->
            <!--</item-help>-->
        <!--</div>-->

        <accordion v-if="helps" :data="helps">
            <template v-slot="slot">
                <div v-html="slot.item.answer"></div>
            </template>
        </accordion>

    </div>
</template>

<script>
    import api from '@/services/Api';

    import PageTitle from '@/components/PageTitle.vue';
    import ItemHelp from '@/items/ItemHelp';
    import Accordion from "@/components/Accordion.vue";

    export default {
        name: 'HelpIndex',
        components: { PageTitle, ItemHelp, Accordion },
        data(){
            return {
                helps: null,
            }
        },
        mounted(){
            this.getHelps();
        },
        methods: {
            // todo refactor to vuex
            getHelps(){
                let url = 'knowledges/qa/issues?per_page=100';
                api({url: url, method: 'GET'})
                    .then(resp => {
                        this.helps = resp.data.data;
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-list {
        margin: 0;
        background: none;
    }
</style>
